import React from 'react';
import { Box } from 'rebass/styled-components';
import PhoneInput from 'react-phone-number-input';
import '../../assets/css/react-phone-number-input.css';

const InputPhone = ({
  name,
  valuesForm,
  setValuesForm,
  keyPressHandler,
  placeholder,
  required
}) => {

  const handleValueChange = e => {
    setValuesForm({ ...valuesForm, [name]: e });
  };
  const buttonId = 'b_' + name;
  return (
    <Box pb={4}>
      <PhoneInput
        id={name}
        name={name}
        international={false}
        defaultCountry="US"
        value={valuesForm[name]}
        onChange={handleValueChange}
        onKeyDown={e => keyPressHandler(e, buttonId, name)}
        placeholder={placeholder}
        required={required}
      />
    </Box>
  );
};

export default InputPhone;
